import React from "react";
import { Link as RouterLink } from "react-router-dom";
import LoginHeader from "../../blocks/LoginHeader";
import { Button, Divider, Image, Text, Link, makeStyles } from "@fluentui/react-components";
import Form from "../form/Form";
import { themeTokens } from "../../utils/Theming";

const title = "Welcome to the OTYS Outlook add in";
const message = "See direct key information of a candidate, relation or relation contact and do quick actions.";

const useStyles = makeStyles({
  container: {
    padding: "20px",
  },
  button: {
    width: "100%",
  },
  learnMore: {
    marginBottom: "16px",
  },
  learnMoreLink: {
    color: themeTokens.colorBrandForeground1,
  },
  divider: {
    margin: "10px 0",
  },
  image: {
    marginTop: "40px",
  },
  imageDivider: {
    marginBottom: "30px",
  },
});

const LoginForm = ({ onLogin, onAzureLogin }) => {
  const styles = useStyles();

  const onSubmit = (formData) => {
    const { username, password } = formData;
    onLogin({ username, password });
  };

  const fields = [
    {
      type: "text",
      name: "username",
      label: "Username",
      validation: (value) => (!value ? "Username is required" : null),
    },
    {
      type: "password",
      name: "password",
      label: "Password",
      validation: (value) => (!value ? "Password is required" : null),
    },
  ];

  return (
    <div className={styles.container}>
      <LoginHeader title={title} message={message} />
      <Text as="p" size={200} block className={styles.learnMore}>
        If you want to learn more,{" "}
        <RouterLink to="/learn-more" className={styles.learnMoreLink}>
          click here
        </RouterLink>.
      </Text>

      <Image width="280" height="178" src="./assets/login-image.png" className={styles.image} />
      <Divider className={styles.imageDivider} />

      <Form title="Login with your OTYS Go! account" buttonText="Login" buttonBottom={false} fields={fields} onSubmit={onSubmit} />

      <Divider className={styles.divider}>Or</Divider>
      <Button
        onClick={onAzureLogin}
        type="button"
        appearance="outline"
        size="medium"
        icon={<Image width="20" height="20" src="./assets/microsoft-icon.png" />}
        className={styles.button}
      >
        Continue with Microsoft Azure
      </Button>

      <Text as="p" size={200} block>
        New here? Don’t have an account yet? Please visit <Link href="https://www.otys.com/en/demo/" target="_blank" rel="noopener noreferrer">this page</Link> to create one.
      </Text>

      <Text as="p" size={200} block>
        If you're facing any issues or have questions, feel free to <Link href="https://www.otys.com/en/support/" target="_blank" rel="noopener noreferrer">contact us</Link> for assistance.
      </Text>
    </div>
  );
};

export default LoginForm;
